// Diccionario de traducciones ES / EN
// El español es el idioma persistente por defecto.
// Todas las cadenas visibles en la UI deben pasar por este diccionario.

const es = {
    // ----- Idioma / Tema -----
    "lang.name": "Español",
    "lang.short": "ES",
    "lang.label": "Idioma",
    "theme.toggle.toDark": "Cambiar a tema oscuro",
    "theme.toggle.toLight": "Cambiar a tema claro",
    "theme.toggle.label": "Tema",

    // ----- Navegación -----
    "nav.home": "Inicio",
    "nav.services": "Servicios",
    "nav.about": "Nosotros",
    "nav.blog": "Noticias",
    "nav.contact": "Contacto",
    "nav.skipToContent": "Saltar al contenido principal",
    "nav.menu.open": "Abrir menú",
    "nav.menu.close": "Cerrar menú",
    "nav.mobileNav.label": "Navegación principal",
    "nav.bottom.home": "Inicio",
    "nav.bottom.services": "Servicios",
    "nav.bottom.about": "Nosotros",
    "nav.bottom.contact": "Contacto",

    // ----- Branding -----
    "brand.name": "IMPO ESCOBEDO",
    "brand.subline": "DE LAGOS",
    "brand.tagline": "Conectamos tu negocio con el mundo",
    "brand.short": "Impo Escobedo",

    // ----- Hero -----
    "hero.eyebrow": "Operaciones globales",
    "hero.title": "Excelencia técnica en logística y comercio internacional",
    "hero.subtitle":
        "Estrategias precisas en importación, exportación y gestión de comercio exterior para la mediana y gran industria.",
    "hero.cta": "Iniciar consulta",
    "hero.secondary": "Conocer servicios",
    "hero.scroll": "Desplázate para descubrir",

    // ----- Métricas -----
    "metrics.years.label": "Años de experiencia",
    "metrics.teus.label": "TEUs movilizados al año",
    "metrics.routes.label": "Rutas comerciales",
    "metrics.accuracy.label": "Precisión en comercio exterior",

    // ----- Servicios (preview en home) -----
    "services.eyebrow": "Áreas de práctica",
    "services.title":
        "Soluciones integrales para cadenas de suministro complejas.",
    "services.subtitle":
        "Tres disciplinas que se entrelazan para darle a tu operación un marco sólido y resiliente.",
    "service.import.title": "Importación y exportación",
    "service.import.short":
        "Gestión end-to-end de fletes marítimos, aéreos y terrestres desde el origen hasta la entrega final.",
    "service.import.description":
        "Coordinamos cada eslabón de la cadena para minimizar tiempos de tránsito y reducir la variabilidad de tu operación.",
    "service.import.feature1": "Fletes marítimos, aéreos y terrestres",
    "service.import.feature2": "Coordinación puerto-a-puerta",
    "service.import.feature3": "Optimización de tránsitos",
    "service.import.feature4": "Seguimiento en tiempo real",

    "service.logistics.title": "Asesoría logística",
    "service.logistics.short":
        "Auditoría de procesos y optimización de rutas para estructuras resilientes y rentables.",
    "service.logistics.description":
        "Diseñamos rutas multimodales a la medida, anticipando disrupciones y protegiendo tu capital de trabajo.",
    "service.logistics.feature1": "Auditoría de procesos",
    "service.logistics.feature2": "Diseño de rutas óptimas",
    "service.logistics.feature3": "Reducción de variabilidad",
    "service.logistics.feature4": "Análisis costo-tiempo",

    "service.customs.title": "Asesoría en comercio exterior",
    "service.customs.short":
        "Cumplimiento normativo riguroso y representación ante autoridades aduaneras.",
    "service.customs.description":
        "Clasificación arancelaria, cálculo de impuestos y gestión legal para que tu mercancía fluya sin fricciones.",
    "service.customs.feature1": "Clasificación arancelaria",
    "service.customs.feature2": "Cálculo de impuestos",
    "service.customs.feature3": "Cumplimiento normativo",
    "service.customs.feature4": "Representación legal",

    "services.cta": "Ver todos los servicios",

    // ----- Proceso / Metodología -----
    "process.eyebrow": "Metodología",
    "process.title": "Arquitectura de operación",
    "process.subtitle":
        "Cuatro etapas que dan estructura a cada operación, desde el primer diagnóstico hasta la entrega final.",
    "process.step1.title": "Diagnóstico estructural",
    "process.step1.text":
        "Análisis exhaustivo de la cadena de suministro actual y de los requerimientos operativos del cliente.",
    "process.step2.title": "Ingeniería de rutas",
    "process.step2.text":
        "Diseño de itinerarios multimodales buscando eficiencia en costos y tiempos.",
    "process.step3.title": "Marco regulatorio",
    "process.step3.text":
        "Gestión anticipada de pedimentos, permisos y normatividad aduanera.",
    "process.step4.title": "Ejecución táctica",
    "process.step4.text":
        "Monitoreo 24/7 y coordinación en puerto hasta la liberación final de la mercancía.",

    // ----- Presencia operativa / Cobertura (home) -----
    "coverage.eyebrow": "Presencia operativa",
    "coverage.title": "Cobertura en el territorio nacional",
    "coverage.subtitle":
        "Cuatro puntos de operación y cuatro corresponsalías que acompañan cada operación.",
    "coverage.map.label": "Esquema de cobertura",
    "coverage.operation.label": "Operación",
    "coverage.correspondent.label": "Corresponsalías",
    "coverage.city.nuevoLaredo": "Nuevo Laredo",
    "coverage.city.reynosa": "Reynosa",
    "coverage.city.matamoros": "Matamoros",
    "coverage.city.mexicali": "Mexicali",
    "coverage.city.colombiaNl": "Colombia, Nuevo León",
    "coverage.city.manzanillo": "Manzanillo",
    "coverage.city.veracruz": "Veracruz",
    "coverage.city.altamira": "Altamira",

    // ----- About preview (home) -----
    "about.eyebrow": "Nuestro legado",
    "about.title": "Previsión en el comercio global",
    "about.lead":
        "Fundados con la visión de aportar rigor analítico al transporte de mercancías, somos una firma boutique de logística internacional.",
    "about.body":
        "No somos intermediarios: somos arquitectos de tu cadena de valor. Nuestro equipo de especialistas aduaneros y estrategas logísticos diseña soluciones a la medida, anticipando disrupciones y garantizando el flujo continuo de capital de trabajo a través de las fronteras.",
    "about.imageEyebrow": "Infraestructura ininterrumpida",
    "about.imageCaption": "Operaciones nocturnas en terminales estratégicas.",
    "about.cta": "Conoce nuestra historia",
    "about.stat1.value": "15+",
    "about.stat1.label": "Años construyendo relaciones",
    "about.stat2.value": "48",
    "about.stat2.label": "Rutas comerciales activas",
    "about.stat3.value": "3,200",
    "about.stat3.label": "TEUs gestionados anualmente",
    "about.stat4.value": "99.8%",
    "about.stat4.label": "Precisión documental",

    // ----- Contact preview (home) -----
    "contact.eyebrow": "Gabinete de consulta",
    "contact.title": "Inicie un diálogo",
    "contact.subtitle":
        "Agende una evaluación técnica de su estructura logística actual. Le responderemos en menos de 24 horas hábiles.",
    "contact.cta": "Enviar solicitud",
    "contact.direct": "O contáctenos directamente:",
    "contact.fields.name": "Nombre completo",
    "contact.fields.company": "Corporativo / Empresa",
    "contact.fields.email": "Correo electrónico",
    "contact.fields.interest": "Área de interés",
    "contact.fields.message": "Requerimiento específico",
    "contact.fields.name.placeholder": "Ej. Carlos Mendoza",
    "contact.fields.company.placeholder": "Razón Social",
    "contact.fields.email.placeholder": "contacto@empresa.com",
    "contact.fields.message.placeholder":
        "Describa brevemente su volumen operativo y rutas principales…",
    "contact.interest.shipping": "Importación marítima",
    "contact.interest.land": "Exportación terrestre",
    "contact.interest.consulting": "Consultoría en comercio exterior",
    "contact.interest.audit": "Auditoría logística",

    // ----- Página Nosotros -----
    "aboutPage.hero.title": "Nosotros",
    "aboutPage.hero.subtitle":
        "Socio estratégico en comercio internacional, con un enfoque de precisión y cumplimiento.",
    "aboutPage.history.eyebrow": "Trayectoria",
    "aboutPage.history.title": "Nuestra historia",
    "aboutPage.history.body1":
        "Impo Escobedo de Lagos nace de la visión de conectar negocios locales con mercados globales, facilitando el comercio internacional a través de servicios altamente especializados.",
    "aboutPage.history.body2":
        "Con años de experiencia en el sector, nos hemos consolidado como una firma referente en asesoría logística y de comercio exterior, ayudando a empresas a expandir sus horizontes comerciales con seguridad.",
    "aboutPage.values.title": "Nuestros valores",
    "aboutPage.values.mission.title": "Misión",
    "aboutPage.values.mission.text":
        "Facilitar el comercio internacional de nuestros clientes con soluciones eficientes y confiables.",
    "aboutPage.values.vision.title": "Visión",
    "aboutPage.values.vision.text":
        "Ser la firma líder en servicios de comercio exterior en la región.",
    "aboutPage.values.commitment.title": "Compromiso",
    "aboutPage.values.commitment.text":
        "Excelencia en cada operación, cumplimiento normativo y satisfacción total del cliente.",

    // ----- Página Servicios -----
    "servicesPage.hero.title": "Nuestros servicios",
    "servicesPage.hero.subtitle":
        "Soluciones integrales de comercio exterior diseñadas para impulsar tu negocio a nivel internacional.",
    "servicesPage.benefits.title": "¿Por qué elegirnos?",
    "servicesPage.benefit.coverage": "Cobertura internacional",
    "servicesPage.benefit.legal": "100% cumplimiento legal",
    "servicesPage.benefit.delivery": "Entregas a tiempo",
    "servicesPage.cta.title": "¿Listo para empezar?",
    "servicesPage.cta.subtitle":
        "Conversemos sobre sus necesidades logísticas y de comercio exterior.",
    "servicesPage.cta.button": "Solicitar asesoría",

    // ----- Página Contacto -----
    "contactPage.hero.title": "Contacto",
    "contactPage.hero.subtitle":
        "¿Listo para expandir su negocio? Estamos aquí para ayudarle.",
    "contactPage.info.title": "Hablemos de su proyecto",
    "contactPage.info.body":
        "Nuestro equipo de expertos está listo para asesorarle en todas sus necesidades de comercio internacional. Contáctenos y descubra cómo podemos ayudarle.",
    "contactPage.info.phone": "Teléfono",
    "contactPage.info.email": "Email",
    "contactPage.info.location": "Ubicación",
    "contactPage.schedule.title": "Horarios de atención",
    "contactPage.schedule.weekdays": "Lunes a viernes",
    "contactPage.schedule.saturday": "Sábado",
    "contactPage.schedule.sunday": "Domingo",
    "contactPage.form.title": "Envíenos un mensaje",
    "contactPage.form.name": "Nombre completo",
    "contactPage.form.email": "Email",
    "contactPage.form.phone": "Teléfono",
    "contactPage.form.message": "Mensaje",
    "contactPage.form.submit": "Enviar mensaje",
    "contactPage.form.sending": "Enviando...",
    "contactPage.form.required": "Campos obligatorios. Sus datos están protegidos y no serán compartidos.",
    "contactPage.success":
        "Mensaje enviado correctamente. Le contactaremos pronto.",
    "contactPage.error": "No se pudo enviar el mensaje. Verifique que el servidor esté funcionando.",

    // ----- Página Noticias -----
    "blogPage.hero.title": "Noticias",
    "blogPage.hero.subtitle":
        "Mantente actualizado con las últimas tendencias, tips y noticias del comercio internacional.",
    "blogPage.loading": "Cargando noticias...",
    "blogPage.empty": "No hay noticias publicadas aún.",
    "blogPage.viewAll": "Ver todas las noticias",
    "blogPage.readMore": "Leer más",
    "newsDetail.back": "Volver a noticias",
    "newsDetail.publishedBy": "Publicado por",
    "newsDetail.author": "Equipo Impo Escobedo",

    // ----- Footer -----
    "footer.copyright": "IMPO ESCOBEDO DE LAGOS",
    "footer.tagline":
        "Comprehensive trade solutions for a modern maritime landscape.",
    "footer.address": "Av. Insurgentes 1245, Elite Business Center, CDMX, México.",
    "footer.directorate": "Directorio",
    "footer.connect": "Conectar",
    "footer.offices": "Oficinas globales",
    "footer.legacy": "Nuestro legado",
    "footer.linkedin": "LinkedIn",
    "footer.legal": "Legal",
    "footer.privacy": "Privacidad",
    "footer.terms": "Términos",
    "footer.services.import": "Importaciones",
    "footer.services.export": "Exportaciones",
    "footer.services.logistics": "Asesoría logística",
    "footer.company.about": "Nosotros",
    "footer.company.news": "Noticias",
    "footer.company.contact": "Contacto",
    "footer.rights": "Todos los derechos reservados.",

    // ----- WhatsApp -----
    "whatsapp.tooltip": "Conversemos por WhatsApp",
    "whatsapp.aria": "Abrir chat de WhatsApp",

    // ----- Errores -----
    "error.generic": "Algo salió mal. Inténtelo nuevamente.",
    "error.connection": "Error de conexión con el servidor",

    // ----- Cantidad métrica (sufijos) -----
    "metric.years.value": "15+",
    "metric.teus.value": "3,200",
    "metric.routes.value": "48",
    "metric.accuracy.value": "99.8%",
};

const en = {
    // ----- Language / Theme -----
    "lang.name": "English",
    "lang.short": "EN",
    "lang.label": "Language",
    "theme.toggle.toDark": "Switch to dark theme",
    "theme.toggle.toLight": "Switch to light theme",
    "theme.toggle.label": "Theme",

    // ----- Navigation -----
    "nav.home": "Home",
    "nav.services": "Services",
    "nav.about": "About",
    "nav.blog": "News",
    "nav.contact": "Contact",
    "nav.skipToContent": "Skip to main content",
    "nav.menu.open": "Open menu",
    "nav.menu.close": "Close menu",
    "nav.mobileNav.label": "Primary navigation",
    "nav.bottom.home": "Home",
    "nav.bottom.services": "Services",
    "nav.bottom.about": "About",
    "nav.bottom.contact": "Contact",

    // ----- Branding -----
    "brand.name": "IMPO ESCOBEDO",
    "brand.subline": "DE LAGOS",
    "brand.tagline": "Connecting your business with the world",
    "brand.short": "Impo Escobedo",

    // ----- Hero -----
    "hero.eyebrow": "Global operations",
    "hero.title": "Technical excellence in logistics and international trade",
    "hero.subtitle":
        "Precise strategies in import, export, and trade management for medium and large industry.",
    "hero.cta": "Start consultation",
    "hero.secondary": "Explore services",
    "hero.scroll": "Scroll to discover",

    // ----- Metrics -----
    "metrics.years.label": "Years of experience",
    "metrics.teus.label": "TEUs moved per year",
    "metrics.routes.label": "Trade routes",
    "metrics.accuracy.label": "Trade accuracy",

    // ----- Services (preview) -----
    "services.eyebrow": "Practice areas",
    "services.title": "Comprehensive solutions for complex supply chains.",
    "services.subtitle":
        "Three disciplines that interlock to give your operation a solid and resilient framework.",
    "service.import.title": "Import & export",
    "service.import.short":
        "End-to-end management of ocean, air, and inland freight from origin to final delivery.",
    "service.import.description":
        "We coordinate every link of the chain to minimize transit times and reduce operational variability.",
    "service.import.feature1": "Ocean, air and inland freight",
    "service.import.feature2": "Door-to-port coordination",
    "service.import.feature3": "Transit optimization",
    "service.import.feature4": "Real-time tracking",

    "service.logistics.title": "Logistics advisory",
    "service.logistics.short":
        "Process auditing and route optimization for resilient and cost-efficient structures.",
    "service.logistics.description":
        "We design tailored multimodal routes, anticipating disruptions and protecting your working capital.",
    "service.logistics.feature1": "Process auditing",
    "service.logistics.feature2": "Optimal route design",
    "service.logistics.feature3": "Variability reduction",
    "service.logistics.feature4": "Cost-time analysis",

    "service.customs.title": "Trade advisory",
    "service.customs.short":
        "Rigorous regulatory compliance and representation before customs authorities.",
    "service.customs.description":
        "Tariff classification, tax computation, and legal handling so your cargo flows without friction.",
    "service.customs.feature1": "Tariff classification",
    "service.customs.feature2": "Tax computation",
    "service.customs.feature3": "Regulatory compliance",
    "service.customs.feature4": "Legal representation",

    "services.cta": "View all services",

    // ----- Process -----
    "process.eyebrow": "Methodology",
    "process.title": "Operational architecture",
    "process.subtitle":
        "Four stages that structure every operation, from the first diagnosis to final delivery.",
    "process.step1.title": "Structural diagnosis",
    "process.step1.text":
        "Exhaustive analysis of the current supply chain and the client's operational requirements.",
    "process.step2.title": "Route engineering",
    "process.step2.text":
        "Design of multimodal itineraries seeking efficiency in costs and time.",
    "process.step3.title": "Regulatory framework",
    "process.step3.text":
        "Proactive management of customs entries, permits, and customs regulations.",
    "process.step4.title": "Tactical execution",
    "process.step4.text":
        "24/7 monitoring and on-port coordination through to the final release of cargo.",

    // ----- Operational presence / Coverage (home) -----
    "coverage.eyebrow": "Operational presence",
    "coverage.title": "Coverage across the national territory",
    "coverage.subtitle":
        "Four operation points and four correspondents that support every operation.",
    "coverage.map.label": "Coverage scheme",
    "coverage.operation.label": "Operation",
    "coverage.correspondent.label": "Correspondents",
    "coverage.city.nuevoLaredo": "Nuevo Laredo",
    "coverage.city.reynosa": "Reynosa",
    "coverage.city.matamoros": "Matamoros",
    "coverage.city.mexicali": "Mexicali",
    "coverage.city.colombiaNl": "Colombia, Nuevo León",
    "coverage.city.manzanillo": "Manzanillo",
    "coverage.city.veracruz": "Veracruz",
    "coverage.city.altamira": "Altamira",

    // ----- About preview (home) -----
    "about.eyebrow": "Our legacy",
    "about.title": "Foresight in global trade",
    "about.lead":
        "Founded with the vision of bringing analytical rigor to cargo transportation, we are a boutique international logistics firm.",
    "about.body":
        "We are not intermediaries: we are architects of your value chain. Our team of customs specialists and logistics strategists designs tailored solutions, anticipating disruptions and ensuring the continuous flow of working capital across borders.",
    "about.imageEyebrow": "Uninterrupted infrastructure",
    "about.imageCaption": "Night operations at strategic terminals.",
    "about.cta": "Discover our history",
    "about.stat1.value": "15+",
    "about.stat1.label": "Years building relationships",
    "about.stat2.value": "48",
    "about.stat2.label": "Active trade routes",
    "about.stat3.value": "3,200",
    "about.stat3.label": "TEUs handled annually",
    "about.stat4.value": "99.8%",
    "about.stat4.label": "Document accuracy",

    // ----- Contact preview (home) -----
    "contact.eyebrow": "Consulting office",
    "contact.title": "Begin a dialogue",
    "contact.subtitle":
        "Schedule a technical assessment of your current logistics structure. We will respond in under 24 business hours.",
    "contact.cta": "Submit request",
    "contact.direct": "Or contact us directly:",
    "contact.fields.name": "Full name",
    "contact.fields.company": "Company",
    "contact.fields.email": "Email",
    "contact.fields.interest": "Area of interest",
    "contact.fields.message": "Specific requirement",
    "contact.fields.name.placeholder": "e.g. Charles Mendoza",
    "contact.fields.company.placeholder": "Legal name",
    "contact.fields.email.placeholder": "contact@company.com",
    "contact.fields.message.placeholder":
        "Briefly describe your operating volume and main routes…",
    "contact.interest.shipping": "Ocean import",
    "contact.interest.land": "Inland export",
    "contact.interest.consulting": "Trade consulting",
    "contact.interest.audit": "Logistics audit",

    // ----- About page -----
    "aboutPage.hero.title": "About us",
    "aboutPage.hero.subtitle":
        "Strategic partner in international trade, with a focus on precision and compliance.",
    "aboutPage.history.eyebrow": "Background",
    "aboutPage.history.title": "Our history",
    "aboutPage.history.body1":
        "Impo Escobedo de Lagos was born from the vision of connecting local businesses with global markets, facilitating international trade through highly specialized services.",
    "aboutPage.history.body2":
        "With years of experience in the sector, we have established ourselves as a leading firm in logistics and trade advisory, helping companies expand their commercial horizons with confidence.",
    "aboutPage.values.title": "Our values",
    "aboutPage.values.mission.title": "Mission",
    "aboutPage.values.mission.text":
        "Facilitate our clients' international trade with efficient and reliable solutions.",
    "aboutPage.values.vision.title": "Vision",
    "aboutPage.values.vision.text":
        "To be the leading firm in foreign trade services in the region.",
    "aboutPage.values.commitment.title": "Commitment",
    "aboutPage.values.commitment.text":
        "Excellence in every operation, regulatory compliance, and total client satisfaction.",

    // ----- Services page -----
    "servicesPage.hero.title": "Our services",
    "servicesPage.hero.subtitle":
        "Comprehensive foreign trade solutions designed to take your business to the next international level.",
    "servicesPage.benefits.title": "Why choose us?",
    "servicesPage.benefit.coverage": "International coverage",
    "servicesPage.benefit.legal": "100% legal compliance",
    "servicesPage.benefit.delivery": "On-time deliveries",
    "servicesPage.cta.title": "Ready to get started?",
    "servicesPage.cta.subtitle":
        "Let's talk about your logistics and trade needs.",
    "servicesPage.cta.button": "Request advisory",

    // ----- Contact page -----
    "contactPage.hero.title": "Contact",
    "contactPage.hero.subtitle":
        "Ready to expand your business? We are here to help.",
    "contactPage.info.title": "Let's discuss your project",
    "contactPage.info.body":
        "Our team of experts is ready to advise you on all your international trade needs. Contact us and discover how we can help.",
    "contactPage.info.phone": "Phone",
    "contactPage.info.email": "Email",
    "contactPage.info.location": "Location",
    "contactPage.schedule.title": "Business hours",
    "contactPage.schedule.weekdays": "Monday to Friday",
    "contactPage.schedule.saturday": "Saturday",
    "contactPage.schedule.sunday": "Sunday",
    "contactPage.form.title": "Send us a message",
    "contactPage.form.name": "Full name",
    "contactPage.form.email": "Email",
    "contactPage.form.phone": "Phone",
    "contactPage.form.message": "Message",
    "contactPage.form.submit": "Send message",
    "contactPage.form.sending": "Sending...",
    "contactPage.form.required":
        "Required fields. Your data is protected and will not be shared.",
    "contactPage.success":
        "Message sent successfully. We will contact you soon.",
    "contactPage.error":
        "Could not send the message. Check that the server is running.",

    // ----- Blog -----
    "blogPage.hero.title": "News",
    "blogPage.hero.subtitle":
        "Stay updated with the latest trends, tips, and news in international trade.",
    "blogPage.loading": "Loading news...",
    "blogPage.empty": "No news published yet.",
    "blogPage.viewAll": "View all news",
    "blogPage.readMore": "Read more",
    "newsDetail.back": "Back to news",
    "newsDetail.publishedBy": "Published by",
    "newsDetail.author": "Impo Escobedo Team",

    // ----- Footer -----
    "footer.copyright": "IMPO ESCOBEDO DE LAGOS",
    "footer.tagline":
        "Comprehensive trade solutions for a modern maritime landscape.",
    "footer.address":
        "Av. Insurgentes 1245, Elite Business Center, CDMX, Mexico.",
    "footer.directorate": "Directorate",
    "footer.connect": "Connect",
    "footer.offices": "Global offices",
    "footer.legacy": "Our legacy",
    "footer.linkedin": "LinkedIn",
    "footer.legal": "Legal",
    "footer.privacy": "Privacy",
    "footer.terms": "Terms",
    "footer.services.import": "Imports",
    "footer.services.export": "Exports",
    "footer.services.logistics": "Logistics advisory",
    "footer.company.about": "About us",
    "footer.company.news": "News",
    "footer.company.contact": "Contact",
    "footer.rights": "All rights reserved.",

    // ----- WhatsApp -----
    "whatsapp.tooltip": "Talk with us on WhatsApp",
    "whatsapp.aria": "Open WhatsApp chat",

    // ----- Errors -----
    "error.generic": "Something went wrong. Please try again.",
    "error.connection": "Server connection error",

    // ----- Metric values -----
    "metric.years.value": "15+",
    "metric.teus.value": "3,200",
    "metric.routes.value": "48",
    "metric.accuracy.value": "99.8%",
};

export const translations = { es, en };

// Helper para recuperación segura con clave de respaldo en español
export const getTranslation = (lang, key) => {
    const dict = translations[lang] || translations.es;
    if (dict[key] !== undefined) return dict[key];
    const fallback = translations.es[key];
    if (fallback !== undefined) return fallback;
    return key;
};

export const SUPPORTED_LANGUAGES = ["es", "en"];
export const DEFAULT_LANGUAGE = "es";
